import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { ajaxErrorHandler, defaultSuccess } from '@legacy-libs/utils';

import { USER_ACTIONS } from '../../redux/auth/actions';
import { resetPassword } from '../../services/api/users';
import ResetPasswordForm from '../forms/ResetPasswordForm';
import LoginLayout from './LoginLayout';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };

    this._handleResetPassword = this._handleResetPassword.bind(this);
  }

  static propTypes = {
    loginRequest: PropTypes.func,
    loginError: PropTypes.string,
    isLoggingIn: PropTypes.bool,
    match: PropTypes.object,
  };

  _handleResetPassword(data) {
    resetPassword({
      token: data.token,
      email: data.email,
      password: data.password,
      password_confirmation: data.repeat_password,
    })
      .then((response) => {
        defaultSuccess('Password reset successfully. You are automatically logged in.');
        this.props.loginRequest(data.email, data.password);
      })
      .catch((e) => {
        ajaxErrorHandler(e);
        this.setState({
          error: true,
        });
      });
  }

  render() {
    return (
      <LoginLayout
        className={
          'm-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin'
        }
      >
        <div className="m-login__wrapper">
          <div className="m-login__logo">
            <a href="/">
              <img src="assets/app/media/img/logos/logo.svg" alt="We Are One World - Crew System" />
            </a>
          </div>

          {this.props.loginError && <div className="alert alert-danger">{this.props.loginError}</div>}
          <div className="m-login__signin">
            <div className="m-login__head">
              <h3 className="m-login__title">Choose a password</h3>
            </div>
            {this.state.error && (
              <div className="alert alert-danger mt-6">
                Something went wrong with setting your password, most likely the link you have is too old or broken, you
                can request a new one{' '}
                <Link className="underline" to={'/?forgotpass=true'}>
                  here
                </Link>
                .
              </div>
            )}
            <ResetPasswordForm
              match={this.props.match}
              onSubmit={this._handleResetPassword}
              forgotPassword={this._toggleForm}
              isLoggingIn={this.props.isLoggingIn}
            />
          </div>
        </div>
      </LoginLayout>
    );
  }
}

const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  loginRequest: (username, password) => dispatch(USER_ACTIONS.loginRequest(username, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
